import { render, staticRenderFns } from "./PlayVideo.vue?vue&type=template&id=5cd87c12&scoped=true"
import script from "./PlayVideo.vue?vue&type=script&lang=js"
export * from "./PlayVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayVideo.vue?vue&type=style&index=0&id=5cd87c12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd87c12",
  null
  
)

export default component.exports